import { TranslateService } from "@ngx-translate/core";
import { Component, OnInit, ViewChild } from "@angular/core";
import { ChecklistModel } from "../shared/model/checklist.model";
import { ChecklistService } from "../shared/service/checklist.service";
import { Router } from "@angular/router";
import { ConfirmComponent } from "../shared/component/confirm/confirm.component";
import { MessageComponent } from "../shared/component/message/message.component";

@Component({
  selector: "app-checklist",
  templateUrl: "./checklist.component.html",
  styleUrls: ["./checklist.component.css"],
})
export class ChecklistComponent implements OnInit {
  @ViewChild(MessageComponent) message: MessageComponent;
  @ViewChild(ConfirmComponent) confirm: ConfirmComponent;

  loading: boolean;

  lastEvent: any;
  totalRecords: number;
  checklists: ChecklistModel[] = [];
  deletableChecklistId: number;

  constructor(
    private checklistService: ChecklistService,
    private translateService: TranslateService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.loading = true;
  }

  lazy(event) {
    this.lastEvent = event;
    let name = event.filters["name"] ? event.filters["name"].value : null;
    this.checklistService
      .getPaginated(event.first, event.rows, name)
      .subscribe((records) => {
        this.checklists = records["rows"] as ChecklistModel[];
        this.totalRecords = records["count"];
        this.loading = false;
      });
  }

  onCopyChecklist = (id: number) => {
    this.checklistService.setId(id);
    this.router.navigate(["/checklist-form", id], {
      queryParams: { isCopy: true },
    });
  };

  openChecklistForm(id?: number) {
    this.checklistService.setId(id);
    this.router.navigate(["/checklist-form", id || '']);
  }

  onClickDeleteChecklist(id: number) {
    this.deletableChecklistId = id;
    this.confirm.confirm();
  }

  acceptDeleteChecklist() {
    if (this.deletableChecklistId) {
      this.checklistService
        .deleteChecklist(this.deletableChecklistId)
        .subscribe(
          () => {
            this.lazy(this.lastEvent);
            this.message.success("Questionário deletado com sucesso");
          },
          () => this.message.error("Erro ao deletar questionário")
        );
    }
  }

  rejectDeleteChecklist() {
    this.deletableChecklistId = undefined;
  }

  translate = (key: string) => this.translateService.instant(key || "invalid");

  tUpper = (key) => this.translate(key).toString().toUpperCase();
  tCap = (key) =>
    this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/checklist/checklist.component.ts